import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function CarouselSlide({ children }: Props) {
  return <div className="relative min-w-0 shrink-0 grow-0 basis-full pl-4">{children}</div>;
}
